import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';

import ManageAccountStatus from 'components/ManageAccountStatus';
import { makeSelectAuth } from 'containers/App/selectors';
import {
  fetchUsers,
  deactivateUser,
  reactivateUser,
} from './actions';
import {
  makeSelectUsers,
  makeSelectLoading,
  makeSelectError,
  makeSelectActionLoading,
  makeSelectActionError,
} from './selectors';

const makeSelectUser = () =>
  createSelector(makeSelectAuth(), (auth) => auth?.loggedInUser);

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
  users: makeSelectUsers(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
  actionLoading: makeSelectActionLoading(),
  actionError: makeSelectActionError(),
});

function mapDispatchToProps(dispatch) {
  return {
    fetchUsers: () => dispatch(fetchUsers()),
    deactivateUser: (userId) => dispatch(deactivateUser(userId)),
    reactivateUser: (userId) => dispatch(reactivateUser(userId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageAccountStatus);
